<template>
  <!-- 新代采单核单页面 -->
  <div v-loading="loading" class="waiting-purchase-detail">
    <!-- 头头头投 -->
    <div class="header">
      <span>核单详情</span>
      <span class="light-color">{{ routeParams.supply_name }}</span>
      <span class="light-color">{{ routeParams.pgname }}</span>
    </div>
    <!-- ============================ 凭证 =============================== -->
    <div class="box">
      档口凭证：
      <el-upload
        class="upload-demo"
        :action="action"
        :multiple="true"
        :show-file-list="true"
        accept="'.jpg,.jpeg,.png,.JPG,.JPEG,.PBG'"
        :on-success="docUploaded"
        list-type="picture-card"
        :on-preview="preview"
        :on-remove="docRemove"
        with-credentials
      >
        <el-button class="linear">上传凭证</el-button>
      </el-upload>
    </div>
    <hr class="splice-line" />
    <!-- ================================ 商品列表 ==================================== -->
    <el-tabs type="border-card" :value="tabs[0].key">
      <el-tab-pane
        :name="tabs[0].key"
        :label="`${tabs[0].name}(${calcTotalMap.total_num})`"
      >
        <div>
          <el-input
            v-model="search_val"
            placeholder="请输入货号/款号/商品名"
            style="width: 300px"
          ></el-input>
          <el-button type="success" @click="getGoodsList">搜 索</el-button>
        </div>
        <!-- ================ 开单列表 ================== -->
        <el-table
          :data="goods_data.list"
          class="goods-table"
          :span-method="kdTableSpan"
          border
          max-height="700"
        >
          <el-table-column label="商品图片" align="center" width="100">
            <template slot-scope="scope">
              <div v-viewer class="image-box">
                <img
                  v-for="(img, index) in scope.row.imgs"
                  :key="index"
                  :src="img"
                  class="viewer-img"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" align="center">
            <template slot-scope="scope">
              <!-- 活动商品要变红 -->
              <div :class="scope.row.activity_goods == 2 ? 'red-font' : ''">
                <div>{{ scope.row.goods_name }}</div>
                <div>-</div>
                <div>{{ scope.row.goods_no }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="款号" align="center" width="130">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.goods_kh"
                @focus="old_kh = scope.row.goods_kh"
                @blur="changeKh(scope.row)"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="整款改价" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.new_goods_price"
                size="small"
                @blur="changeGoodsPrice(scope.row)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="SKU改价" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.new_sku_price"
                size="small"
                @blur="changeSkuPrice(scope.row)"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column label="代采单价" prop="plan_price" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.plan_price }}
              </div>
              <strike v-show="scope.row.remove_price">
                {{ scope.row.remove_price }}
              </strike>
            </template>
          </el-table-column>
          <el-table-column
            label="颜色"
            prop="co_val"
            align="center"
          ></el-table-column>
          <el-table-column
            label="尺码"
            prop="si_val"
            align="center"
          ></el-table-column>
          <el-table-column label="选择开单" align="center">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  class="full"
                  @click="cgDialog(scope.row.goods_no)"
                >
                  {{ scope.row.cg_num }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="剩余数量" prop="plan_num" align="center">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  class="full"
                  @click="cgDialog(scope.row.goods_no)"
                >
                  <!-- {{Math.max(scope.row.plan_num - scope.row.cg_num - scope.row.stop_num, 0)}} -->
                  {{ calcLeftNum(scope.row) }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="前置数量" prop="dk_num" align="center">
            <template slot-scope="scope">
              <div>
                <!-- 超过计划数量的就是前置数量 -->
                {{ calcDkNum(scope.row) }}
                <!-- {{Math.abs(Math.min(scope.row.plan_num - scope.row.cg_num  - scope.row.stop_num, 0))}} -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="实付金额小计" align="center" width="180">
            <template slot-scope="scope">
              <div>
                <div>开单</div>
                <div>{{ scope.row.total_num }}件</div>
                <div>¥{{ scope.row.total_price }}</div>
                <div class="light-color">
                  活动费¥{{ scope.row.activity_fee }}
                </div>
                <div class="light-color">
                  平台佣金¥{{ scope.row.service_fee }}
                </div>
                <div class="light-color">
                  小店佣金¥{{ scope.row.dispense_commission_amount }}
                </div>
                <div class="light-color">
                  退货服务费¥{{ scope.row.refund_service_fee }}
                </div>
                <div
                  class="blue-font pointer"
                  @click="showBillingDetail(scope.row)"
                >
                  >>>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div v-show="!billing_info.is_sample_plan">
                <el-date-picker
                  v-model="scope.row.goods_return_day"
                  type="date"
                  value-format="yyyy-MM-dd"
                  size="small"
                  style="width: 140px"
                  placeholder="选择日期"
                  @change="setGoodsReturnDay($event, scope.row)"
                >
                </el-date-picker>
                <br />
                <br />
                <el-button
                  v-if="scope.row.is_multi_phase"
                  size="small"
                  class="multi-phase-btn"
                  @click="showMultiGoods(scope.row.goods_no)"
                >
                  有多期
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- =========== 开单统计 ============ -->
        <div class="space-between span-top yellow-background">
          <div>
            <el-button type="primary" size="mini" @click="resetAllCgNum">
              重置数量</el-button
            >
            <el-button type="primary" size="mini" @click="setAllCgNum">
              全选</el-button
            >
          </div>
          <div>
            实付金额合计：共{{ calcTotalMap.total_goods }}款，{{
              calcTotalMap.total_num
            }}件，记¥{{ calcTotalMap.total_price }}
          </div>
        </div>
      </el-tab-pane>
      <!-- ================= 断货列表 ================== -->
      <el-tab-pane
        v-if="billing_info.can_stop_goods"
        :name="tabs[1].key"
        :label="`${tabs[1].name}(${calcTotalMap.stop_num})`"
      >
        <div>
          <el-input
            v-model="search_val"
            placeholder="请输入货号/款号/商品名"
            style="width: 300px"
          ></el-input>
          <el-button type="success" @click="getGoodsList">搜 索</el-button>
        </div>
        <el-table
          :data="goods_data.list"
          border
          :span-method="dhTableSpan"
          max-heigth="700"
        >
          <el-table-column label="商品图片" align="center" width="100">
            <template slot-scope="scope">
              <div v-viewer class="image-box">
                <img
                  v-for="(img, index) in scope.row.imgs"
                  :key="index"
                  :src="img"
                  class="viewer-img"
                />
              </div>
            </template>
          </el-table-column>

          <el-table-column label="商品名称" align="center">
            <template slot-scope="scope">
              <!-- 活动商品要变红 -->
              <div :class="scope.row.activity_goods == 2 ? 'red-font' : ''">
                <div>{{ scope.row.goods_name }}</div>
                <div>-</div>
                <div>{{ scope.row.goods_no }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="款号" align="center" width="130">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.goods_kh"
                @focus="old_kh = scope.row.goods_kh"
                @blur="changeKh(scope.row)"
              >
              </el-input>
            </template>
          </el-table-column>

          <el-table-column label="代采单价" prop="plan_price" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.plan_price }}
              </div>
              <strike v-show="scope.row.remove_price">
                {{ scope.row.remove_price }}
              </strike>
            </template>
          </el-table-column>
          <el-table-column
            label="颜色"
            prop="co_val"
            align="center"
          ></el-table-column>
          <el-table-column
            label="尺码"
            prop="si_val"
            align="center"
          ></el-table-column>
          <el-table-column label="选择断货" prop="co_val" align="center">
            <template slot-scope="scope">
              <div>
                <el-input-number
                  v-model="scope.row.stop_num"
                  :min="0"
                  :max="
                    scope.row.plan_num -
                    scope.row.cg_num -
                    scope.row.temp_stop_num
                  "
                  size="small"
                ></el-input-number>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="剩余数量" prop="plan_num" align="center">
            <template slot-scope="scope">
              <div @click="tapStopTableLeftNum(scope.row)">
                {{ calcLeftNum(scope.row) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="" align="center">
            <template slot-scope="scope">
              <div>
                <div>断货</div>
                {{ calcGoodsStopNum(scope.row) }}
                <!-- {{calcLeftNum(scope.row)}} -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="space-between span-top yellow-background">
          <div>
            <el-button type="primary" size="mini" @click="resetStopNum">
              重置数量</el-button
            >
            <el-button type="primary" size="mini" @click="allStopNum">
              全选</el-button
            >
          </div>
          <div>
            实付金额合计：共{{ calcTotalMap.total_goods }}款，{{
              calcTotalMap.total_num
            }}件，记¥{{ calcTotalMap.total_price }}
          </div>
        </div>
      </el-tab-pane>
      <!-- ================ 急救箱列表 ================== -->
      <el-tab-pane
        v-if="not_planid"
        :name="tabs[2].key"
        :label="`${tabs[2].name}(${stock_goods})`"
      >
        <stock-out-goods
          ref="stockOutGoodsRef"
          :pgid="Number(routeParams.pgid)"
          :supply_id="Number(routeParams.supply_id)"
          @setNum="setStockNum"
        >
        </stock-out-goods>
      </el-tab-pane>
    </el-tabs>
    <!-- ====================================== 活动费用商品抵扣 ============================= -->
    <div v-if="activityGoodsInfo.length > 0 || isCutActivityGoods === false">
      <div class="grey-bar span-top activity-title">
        <div>活动费商品抵扣</div>
        <div>
          是否扣取活动费商品：
          <el-switch v-model="isCutActivityGoods" @change="handleDealGoodsInfo">
          </el-switch>
        </div>
      </div>
      <el-table :data="activityGoodsInfo" border>
        <el-table-column
          label="活动时间"
          prop="activity_time"
          align="center"
        ></el-table-column>
        <el-table-column
          label="商品名称"
          prop="goods_name"
          align="center"
        ></el-table-column>
        <el-table-column
          label="货号"
          prop="goods_no"
          align="center"
        ></el-table-column>
        <el-table-column
          label="颜色/尺码"
          prop="co_si"
          align="center"
        ></el-table-column>
        <el-table-column
          label="SKU编号"
          prop="sku"
          align="center"
        ></el-table-column>
        <el-table-column
          label="单件优惠额"
          prop="activity_fee"
          align="center"
        ></el-table-column>
        <el-table-column
          label="抵扣数量"
          prop="num"
          align="center"
        ></el-table-column>
        <el-table-column
          label="订单ID"
          prop="order_id"
          align="center"
        ></el-table-column>
        <el-table-column
          label="活动ID"
          prop="activity_id"
          align="center"
        ></el-table-column>
        <el-table-column
          label="活动类型"
          prop="activity_type_text"
          align="center"
        ></el-table-column>
        <el-table-column
          label="活动名称"
          prop="activity_name"
          align="center"
        ></el-table-column>
        <el-table-column
          label="活动费抵扣小计"
          prop="activity_fee_amount"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="flex-row-reverse span-top yellow-background">
        <div>活动商品抵扣费用合计：¥{{ activity_fee_amount }}</div>
      </div>
    </div>
    <!-- ====================================== 开单信息 ============================= -->
    <div v-if="routeParams.settle_type == 1">
      <template
        v-if="
          (rebateData.list.length > 0 && rebateData.total_ded > 0) ||
          openReturnProfitDed === false
        "
      >
        <div class="grey-bar span-top flex-row">
          <span>让利佣金账单抵扣明细</span>
          <div>
            是否使用让利抵扣：
            <el-switch
              v-model="openReturnProfitDed"
              active-text="开启"
              inactive-text="关闭"
              @change="handleProfitSwitchChange"
            ></el-switch>
          </div>
        </div>
        <el-table :data="rebateData.list" border>
          <el-table-column
            label="让利账期"
            prop="reporting_period"
            align="center"
          ></el-table-column>
          <el-table-column label="让利账单编号" prop="bill_no" align="center">
          </el-table-column>
          <el-table-column
            label="让利账单确认时间"
            prop="confirm_time"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="总结算金额"
            prop="amount_price"
            align="center"
          ></el-table-column>
          <el-table-column
            label="已抵扣金额"
            prop="already_ded_price"
            align="center"
          ></el-table-column>
          <el-table-column
            label="本单抵扣金额"
            prop="ded_price"
            align="center"
          ></el-table-column>
          <el-table-column
            label="剩余可抵扣"
            prop="remaining_ded_price"
            align="center"
          ></el-table-column>
        </el-table>
        <div
          class="grey-bar span-top"
          style="text-align: right; color: #f56c6c"
        >
          合计让利佣金抵扣金额：¥{{ rebateData.total_ded || "0.00" }}
        </div>
      </template>
      <div class="grey-bar span-top">开单信息</div>
      <el-table :data="kdInfo()" border>
        <el-table-column
          label="交易方式"
          prop="cg_type"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="!billing_info.is_sample_plan"
          label="开单方式"
          align="center"
        >
          <template #default>
            <div>
              <div>
                <el-radio
                  v-model="kd_form.order_type"
                  value="1"
                  label="1"
                  size="small"
                  >实数单</el-radio
                >
              </div>
              <div>
                <el-radio
                  v-model="kd_form.order_type"
                  value="2"
                  label="2"
                  size="small"
                  >排单单</el-radio
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!billing_info.is_sample_plan"
          label="排单承诺回货日期"
          align="center"
          width="150"
        >
          <template #default>
            <div>
              <el-date-picker
                v-model="kd_form.order_return_day"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                style="width: 140px"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="开单价合计"
          prop="total"
          align="center"
        ></el-table-column>
        <el-table-column
          label="活动服务费合计"
          prop="activity_fee"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="`平台佣金合计(${billing_info.service_fee_rate})`"
          prop="service_fee"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="store_fee"
          label="小店佣金"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          :label="`退货服务费合计(${billing_info.refund_fee_rate})`"
          prop="refund_fee"
          align="center"
        ></el-table-column>
        <el-table-column
          label="实付金额合计"
          prop="total_price"
          align="center"
        ></el-table-column>
        <el-table-column label="商品抵扣" align="center" width="180">
          <template #default>
            <div class="center">
              <div>
                {{ deductPrice }}
              </div>
              <div
                v-if="!isAutoDeduct && isDeductPlan"
                style="margin-left: 8px"
              >
                <el-button
                  v-if="not_planid"
                  type="primary"
                  size="small"
                  @click="selectDedData"
                  >选择商品抵扣</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="活动费商品抵扣" align="center">
          <template #default>
            <div>
              {{ activity_fee_amount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="让利佣金抵扣金额"
          align="center"
          prop="total_ded"
        >
        </el-table-column>
        <el-table-column label="实际结算金额" align="center">
          <template>
            <div>
              {{ deductRebatePayPrice }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- ====================================== 收款人信息 ============================= -->
    <div v-if="billing_info.pay_tool != 2">
      <div class="grey-bar span-top">收款人信息</div>
      <el-table :data="billing_info.supply_payee" border>
        <el-table-column label="选择" align="center">
          <template slot-scope="scope">
            <div>
              <el-radio v-model="choice_payee" :label="scope.$index">
                &nbsp;</el-radio
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="payee_name"
          label="收款人名称"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="payee_bank"
          label="收款人银行"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cnap_name"
          label="收款人银行支行"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="payee_bank_account"
          label="收款账号"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
      </el-table>
    </div>

    <!-- ====================================== 填写备注 ============================= -->
    <div class="space-between span-top" style="align-items: flex-end">
      <!--  -->
      <div style="width: 90%">
        <el-input
          v-model="kd_form.note"
          type="textarea"
          placeholder="填写备注"
          rows="3"
        ></el-input>
      </div>

      <div>
        <el-button type="primary" @click="submit">提交开单</el-button>
      </div>
    </div>

    <!-- ============= 开单数量弹窗 =============== -->
    <kd-dialog ref="kdDialogRef" @confirm="confirmDkNum"></kd-dialog>

    <!-- ============= 多期页面弹窗 =============== -->
    <multi-phase-goods ref="multiPhaseGoodsRef"></multi-phase-goods>

    <!-- =================== 可抵扣商品列表在最后面显示 =========================== -->
    <ded-table
      ref="dedTableRef"
      @on-confirm="handleDeductGoodsConfirm"
    ></ded-table>

    <!-- =================== 可抵扣商品列表在最后面显示 =========================== -->
    <billing-detail ref="billingDetailRef"></billing-detail>

    <div v-if="isAutoDeduct && isDeductPlan">
      <div class="grey-bar">
        抵扣商品明细（汇总：共{{ result.total_num }}件，抵扣金额 ¥
        {{ result.total_amount }}）
      </div>
      <YsDataTable
        v-model="refresh"
        :init-params="{
          supply_id: routeParams.supply_id,
          price: kdInfo()[0].total_price,
        }"
        :fetch-method="fetchMethod"
        :columns="columns"
        :use-pagination="false"
        max-height="400"
        use-data-field
        @on-fetch-success="handleFetchSuccess"
      >
        <template #goods_img="{ row }">
          <div
            style="
              width: 40px;
              height: 40px;
              overflow: hidden;
              cursor: pointer;
              margin: auto;
            "
            @click="handleViewImages(row.imgs)"
          >
            <img style="width: 100%; height: 100%" :src="row.goods_img" />
          </div>
        </template>
      </YsDataTable>
    </div>
  </div>
</template>

<script>
import StockOutGoods from "./components/StockOutGoods.vue";
import KdDialog from "./components/KdDialog.vue";
import DedTable from "./components/DedTable.vue";
import MultiPhaseGoods from "./components/MultiPhaseGoods.vue";
import BillingDetail from "./components/BillingDetail.vue";
import { viewImg } from "@/tool/helper.js";
import { listActivityGoods } from "@/controller/purchaseManagement.js";
import * as vendorProfitConcessionApi from "@/controller/vendorProfitConcession3461.js";
import { completeMoneyDecimal } from "@/utils/tools/index.js";
import addZeroes from "@/utils/addZeroes.js";
import apiBaseURL from "@/utils/baseUrl.js";
import { postGetDedDataByPrice } from "@/openapi/erp/wcgOrder.js";

const PLAN_IDS = ["9", "10", "11"]; // 9买版计划 10 爆款备货计划 11提前代采
const constantMap = {
  isProfitOpen: "1",
  isProfitClose: "2",
  isAutoDeduct: "1",
  isDeductPlan: 1,
};
export default {
  components: {
    StockOutGoods,
    KdDialog,
    DedTable,
    MultiPhaseGoods,
    BillingDetail,
  },
  data() {
    const routeParams = this.$route.params;
    routeParams.supply_name = routeParams.supply_name.replaceAll("$s", "/");
    routeParams.pgname = routeParams.pgname.replaceAll("$s", "/");
    return {
      constantMap,
      loading: false,
      // 定义所有的请求url
      urls: {
        get_goods_list: "/erp/WcgOrder/getBillingList",
        change_kh: "/storage/Goods/changeGoodsKh",
        change_price: "/erp/WcgOrder/setBillingPrice",
        get_goods_fee: "/erp/WcgOrder/getGoodsFee",
        set_num: "/erp/WcgOrder/setBillingNum",
        get_ded: "/buyer/purchase/dedOfVerifyPurchase",
        get_billing_info: "/erp/WcgOrder/getBillingInfoOnPc",
        submit: "/erp/WcgOrder/submitBilling",
        multi_phase_goods: "/erp/WcgOrder/getMultiPhaseGoods",
        get_goods_price: "/erp/WcgOrder/getGoodsPrice",
        set_goods_return_day: "/erp/WcgOrder/setGoodsReturnDay",
        get_billing_detail: "/erp/WcgOrder/getBillingDetailOnH5",
      },

      // url路由上面的参数
      routeParams,
      // 没有计划id
      not_planid: routeParams.planid == 0,
      // 是否是买版计划
      isBuyEditionPlan: routeParams.ptype == 10,
      // 档口凭证
      docs: [],
      // 商品列表的tabs切换
      tabs: [
        { name: "开单", key: "1" },
        { name: "断货", key: "2" },
        { name: "急救箱", key: "3" },
      ],
      // 待开单商品
      goods_data: {
        // 列表
        list: [],
        // page: 1,
        // page_total: 0,
        params: {
          page: 1, // 页码
        },
      },
      // 修改款号时, 暂存旧款号
      old_kh: "",
      // 修改价格时, 暂存旧价格
      old_price: "",
      // 每个标记每个款号的第一个sku需要合并多少行
      span_method_mark: {},
      // 每个货号下的sku, 并且每个sku在第几行
      goods_sku_map: {}, // {$goods_no=>{$sku=>$table_index}}
      ded_data: {
        list: [],
        sum_price: "0.00",
        sum_num: 0,
      },
      kd_form: {
        order_type: "", // 开单方式
        order_return_day: "", // 排单承诺日期
        // ded_detail: [],
        // ded_price: '0.00',
        note: "",
      },

      // 收款人信息
      billing_info: {
        supply_payee: [],
        is_sample_plan: 0,
        can_stop_goods: 0,
        pay_tool: "",
        refund_fee_rate: "",
        service_fee_rate: "",
        is_auto_ded: "",
        is_ded_plan: 1,
      },
      // 选中的收款人信息
      choice_payee: 0,
      // 搜索
      search_val: "",
      // 急救箱数量
      stock_goods: 0,
      // 活动费商品抵扣
      activityGoodsInfo: [],
      // 用于暂存活动费用数据，无需重新去请求接口
      activityGoodsInfoStag: [],
      // 是否扣取活动费商品
      isCutActivityGoods: true,
      activity_fee_amount: "0.00",
      activityFeeAmountStag: "0.00",
      saf_ids: [],
      rebateData: {
        list: [],
        total_ded: "",
      }, // 让利数据
      openReturnProfitDed: true, // 是否开启让利账单抵扣
      action: `${apiBaseURL}/erp/common/erpUploadFile`,
      showDeductionGoodsDetail: false,
      refresh: false,
      fetchMethod: postGetDedDataByPrice,
      columns: [
        {
          label: "抵扣商品ID",
          prop: "wdid",
          fixed: "left",
        },
        {
          label: "抵扣生成时间",
          prop: "wd_create_date",
        },
        {
          label: "商品图片",
          slot: "goods_img",
        },
        {
          label: "商品名称",
          prop: "goods_name",
        },
        {
          label: "商品货号",
          prop: "goods_no",
        },
        {
          label: "商品款号",
          prop: "goods_kh",
        },
        {
          label: "颜色",
          prop: "co_val",
        },
        {
          label: "尺码",
          prop: "si_val",
        },
        {
          label: "代采价",
          prop: "price",
        },
        {
          label: "抵扣金额",
          prop: "can_use_price",
        },
      ],
      result: {
        total_amount: "0.00",
      },
    };
  },

  computed: {
    // 计算总开单实付金额
    // 计算总开单款数
    // 计算总开单件数
    calcTotalMap() {
      const rs = {
        total_origin_cg_price: "0.00", // 统计原价金额(未减去活动费用那些的)
        total_price: "0.00", // 实付金额
        total_goods: 0, // 款
        total_num: 0, // 件
        total_activity_fee: "0.00", // 活动费用
        total_refund_fee: "0.00", // 退货服务费
        total_service_fee: "0.00", // 平台佣金
        store_fee: "0.00", // 小店佣金
        stop_num: 0,
        stop_goods: 0,
      };
      const goodsLooped = []; // 记录已经循环过的goods_no
      const goodsLoopedStop = [];
      this.goods_data.list.forEach((row) => {
        rs.stop_num += row.stop_num;
        if (row.stop_num > 0 && !goodsLoopedStop.includes(row.goods_no)) {
          rs.stop_goods += 1;
          goodsLoopedStop.push(row.goods);
        }
        if (row.cg_num == 0) return;
        rs.total_num += Number(row.cg_num);
        // 金额统计的时候, 每行的价格都是一样的, 所以统计一行就行了
        if (goodsLooped.includes(row.goods_no)) return;
        goodsLooped.push(row.goods_no);
        rs.total_goods += 1;
        rs.total_origin_cg_price = this._bcAdd(
          rs.total_origin_cg_price,
          row.origin_cg_price
        );
        rs.total_price = this._bcAdd(rs.total_price, row.total_price);
        rs.total_activity_fee = this._bcAdd(
          rs.total_activity_fee,
          row.activity_fee
        );
        rs.total_refund_fee = this._bcAdd(
          rs.total_refund_fee,
          row.refund_service_fee
        );
        rs.total_service_fee = this._bcAdd(
          rs.total_service_fee,
          row.service_fee
        );
        console.log(row, "row");
        rs.store_fee = this._bcAdd(
          rs.store_fee,
          row.dispense_commission_amount
        );
      });
      return rs;
    },
    isAutoDeduct() {
      return this.billing_info.is_auto_ded === constantMap.isAutoDeduct;
    },
    // 是否可以使用抵扣，买版计划和爆版备货计划不可以使用抵扣
    isDeductPlan() {
      return this.billing_info.is_ded_plan === constantMap.isDeductPlan;
    },
    // 商品抵扣金额
    deductPrice() {
      if (!this.isDeductPlan) {
        return 0;
      }
      return this.isAutoDeduct
        ? this.result.total_amount
        : this.ded_data.sum_price;
    },
    // 实付金额
    actualPayPrice() {
      return this.calcTotalMap.total_price;
    },
    // 扣除商品抵扣后需要支付金额，即实付金额-商品抵扣金额
    deductPayPrice() {
      return parseFloat(
        this.$math.evaluate(`${this.actualPayPrice} - ${this.deductPrice}`)
      ).toFixed(2);
    },
    // 扣除活动抵扣金额后需要支付金额，即实付金额-商品抵扣金额-活动费用抵扣
    deductActivityPayPrice() {
      return parseFloat(
        this.$math.evaluate(
          `${this.deductPayPrice} - ${this.activity_fee_amount}`
        )
      ).toFixed(2);
    },
    // 扣除让利佣金后需要支付的金额，即最后需要支付的实际金额
    deductRebatePayPrice() {
      return parseFloat(
        this.$math.evaluate(
          `${this.deductActivityPayPrice} - ${this.rebateData.total_ded || "0"}`
        )
      ).toFixed(2);
    },
  },
  watch: {
    // 如果实付金额发生变化, 重新获取活动费商品抵扣数据
    "calcTotalMap.total_price": function calcTotalMapTotalPrice(newVal) {
      this.getActivityGoodsInfo(
        parseFloat(this.$math.evaluate(`${newVal} - ${this.deductPrice}`))
      );
      if (this.isAutoDeduct && this.isDeductPlan) {
        this.refresh = true;
      }
      this.ded_data = this.$options.data.call(this).ded_data;
    },
    // 如果商品抵扣金额变化，则重新获取接口计算活动抵扣和让利抵扣
    deductPrice: function resultTotalAmount() {
      this.getActivityGoodsInfo(
        parseFloat(
          this.$math.evaluate(
            `${this.calcTotalMap.total_price} - ${this.deductPrice}`
          )
        )
      );
    },
    deductPayPrice: {
      handler(value) {
        this.getActivityGoodsInfo(value);
      },
    },
    deductActivityPayPrice: {
      handler(value) {
        this.handleGetRebateByMoney(value);
      },
    },
  },
  created() {
    this.getGoodsList();
    this.getBillingInfo();
  },
  methods: {
    // 获取开单信息
    getBillingInfo() {
      this.post(this.urls.get_billing_info, {
        supply_id: this.routeParams.supply_id,
        planid: this.routeParams.planid,
      }).then((data) => {
        this.billing_info = data;
      });
    },
    // 获取活动抵扣商品
    getActivityGoodsInfo(amount) {
      if (PLAN_IDS.includes(this.routeParams.ptype)) {
        return;
      }
      console.log("获取活动抵扣商品");
      const params = {
        supply_id: this.routeParams.supply_id,
        amount,
      };
      listActivityGoods(params)
        .then((data) => {
          const {
            goods_list: goodsList,
            activity_fee_amount: activityFeeAmount,
            saf_ids: safIds,
          } = data;
          if (this.isCutActivityGoods) {
            this.activityGoodsInfo = goodsList;
            this.activity_fee_amount = activityFeeAmount;
          } else {
            this.activityGoodsInfoStag = goodsList;
            this.activityFeeAmountStag = activityFeeAmount;
          }
          this.saf_ids = safIds;
          // 因为价格改动，重新获取让利数据
          this.handleGetRebateByMoney();
        })
        .catch(this.$noop);
    },
    // 档口凭证上传成功
    docUploaded({ code, data, msg }, file, fileList) {
      if (String(code) === "200") {
        this.docs.push(data.origin_files[0]);
      } else {
        const index = fileList.find((item) => item.uid === file.uid);
        fileList.splice(index, 1);
        this.$message.error(msg);
      }
    },

    // 删除凭证
    docRemove(file) {
      const fileUrl = file.response.data.origin_files[0];
      const index = this.docs.indexOf(fileUrl);
      if (index > -1) {
        this.docs.splice(index, 1);
      }
      // console.log(this.docs);
    },

    // 获取商品列表
    getGoodsList() {
      let params = {
        supply_id: this.routeParams.supply_id,
        pgid: this.routeParams.pgid,
        search_val: this.search_val,
        planid: this.routeParams.planid,
        is_dispense: this.routeParams.is_dispense,
      };
      params = Object.assign(params, this.goods_data.params);
      this.post(this.urls.get_goods_list, params)
        .then((data) => {
          // 处理获取的list
          this._splitListAndMark(data.list);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    // 处理获取的list
    // 需要一个sku一行, 然后标记每个款号的第一个sku需要合并多少行
    _splitListAndMark(list) {
      this.goods_data.list = [];
      this.span_method_mark = {};
      this.goods_sku_map = {};
      let loop = 0;
      list.forEach((row) => {
        const skuLength = row.detail.length;
        if (skuLength == 0) return;
        const { sku } = row.detail[0];
        this.span_method_mark[sku] = skuLength;
        this.goods_sku_map[row.goods_no] = {};
        const _row = JSON.parse(JSON.stringify(row));
        _row.total_num = _row.cg_num;
        _row.total_price = _row.cg_price;
        delete _row.cg_num; // 这里一定要delete 不然 assign的时候会被覆盖
        delete _row.cg_price;
        delete _row.detail;

        row.detail.forEach((skuRow) => {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          skuRow.new_sku_price = ""; // 用于sku改价
          skuRow.new_goods_price = ""; // 用于整款改价
          skuRow.temp_stop_num = skuRow.stop_num; // 用于算断货的最大数量
          const _skuRow = JSON.parse(JSON.stringify(skuRow));
          _skuRow.cg_num = Number(_skuRow.cg_num);
          _skuRow.plan_num = Number(_skuRow.plan_num);
          _skuRow.stop_num = Number(_skuRow.stop_num);
          this.goods_data.list.push(
            Object.assign(_skuRow, _row, {
              remove_price: _skuRow.remove_price,
            })
          );

          this.goods_sku_map[row.goods_no][skuRow.sku] = loop;
          loop += 1;
        });
      });
    },

    // 开单列表的合并行
    kdTableSpan({ row, columnIndex }) {
      let rs = 1;
      // 只有 这几列需要合并
      if ([0, 1, 2, 3, 11, 12].includes(columnIndex)) {
        // 有定义就合并行, 因为已经定义好了
        rs = this.span_method_mark[row.sku] || 0;
      }

      return {
        rowspan: rs,
        colspan: rs > 0 ? 1 : 0,
      };
    },

    // 断货列表合并行
    dhTableSpan({ row, columnIndex }) {
      let rs = 1;
      // 只有 这几列需要合并
      if ([0, 1, 2, 3, 8].includes(columnIndex)) {
        // 有定义就合并行, 因为已经定义好了
        rs = this.span_method_mark[row.sku] || 0;
      }

      return {
        rowspan: rs,
        colspan: rs > 0 ? 1 : 0,
      };
    },

    // 修改款号
    changeKh(row) {
      // 无修改, 不请求
      if (this.old_kh == row.goods_kh) return;
      // console.log(args);
      const params = {
        goods_no: row.goods_no,
        goods_kh: row.goods_kh,
      };
      this.post(this.urls.change_kh, params)
        .then(() => {
          this.$message.success("修改成功");
        })
        .catch(() => {
          row.goods_kh = this.old_kh;
        });
    },

    // 整款改价
    changeGoodsPrice(row) {
      if (row.new_goods_price === "") return;
      const params = {
        goods_no: row.goods_no,
        price: row.new_goods_price,
      };
      this._changePrice(params, row, 2);
    },

    // sku改价
    changeSkuPrice(row) {
      if (row.new_sku_price === "") return;
      const params = {
        sku: row.sku,
        price: row.new_sku_price,
      };
      this._changePrice(params, row, 1);
    },

    // 改价之后的操作
    // @param action {1:sku改价, 2:整款改价}
    _changePrice(params, row, action) {
      params.price = this.priceFormat(params.price);
      params.supply_id = this.routeParams.supply_id;
      params.planid = this.routeParams.planid || 0;
      params.is_dispense = this.routeParams.is_dispense;
      this.post(this.urls.change_price, params).then(() => {
        this.$message.success("修改价格成功");
        // 执行改价, 然后再请求改价之后的费用
        let cgNum = 0;
        if (action == 2) {
          // 改整款价格的时候, 就把全sku的显示价格都改了
          this._loopSku(row.goods_no, (skuRow) => {
            cgNum += row.cg_num;
            this._setRowPrice(skuRow, params.price);
          });
        } else {
          cgNum = row.cg_num;
          this._setRowPrice(row, params.price);
        }
        if (cgNum == 0) {
          return;
        }
        // 开单数量 > 0 再去取金额小计
        this.getGoodsFee(row.goods_no);
      });
    },

    // 重新设置每行的价格
    _setRowPrice(row, newPrice) {
      row.new_sku_price = "";
      row.new_goods_price = "";

      if (newPrice != row.plan_price && row.remove_price == "") {
        row.remove_price = row.plan_price;
      }
      if (row.remove_price == newPrice) {
        row.remove_price = "";
      }
      row.plan_price = newPrice;
    },

    // 获取开单费用
    getGoodsFee(goodsNo) {
      this.post(this.urls.get_goods_fee, {
        supply_id: this.routeParams.supply_id,
        is_dispense: this.routeParams.is_dispense,
        goods_no: goodsNo,
        planid: this.routeParams.planid,
      }).then((rs) => {
        this._loopSku(goodsNo, (row) => {
          row.activity_fee = rs.activity_fee;
          row.refund_service_fee = rs.refund_service_fee;
          row.service_fee = rs.service_fee;
          row.total_num = rs.total_num;
          row.total_price = rs.total_price;
          row.origin_cg_price = rs.origin_total_price;
          row.dispense_commission_amount = rs.dispense_commission_amount;
        });
        this.getActivityGoodsInfo(
          parseFloat(
            this.$math.evaluate(
              `${this.calcTotalMap.total_price} - ${this.deductPrice}`
            )
          )
        );
      });
    },

    // 获取sku的价格
    getGoodsPrice(goodsNo) {
      const { supply_id: supplyId } = this.routeParams;
      const { planid } = this.routeParams;
      const { is_dispense: isDispense } = this.is_dispense;
      this.post(this.urls.get_goods_price, {
        goods_no: goodsNo,
        supply_id: supplyId,
        planid,
        is_dispense: isDispense,
      }).then((rs) => {
        // this._loopSku(rs);
        rs.deatil.forEach((item) => {
          const { sku } = item;
          if (typeof this.goods_sku_map[goodsNo][sku] === "undefined") return;
          const tableIndex = this.goods_sku_map[goodsNo][sku];
          this.goods_data.list[tableIndex].plan_price = item.plan_price;
          this.goods_data.list[tableIndex].remove_price = item.remove_price;
        });
      });
    },

    // 获取货号下的代采数量
    _loopSku(goodsNo, fun) {
      // for (const sku in this.goods_sku_map[goodsNo]) {
      //   const table_index = this.goods_sku_map[goodsNo][sku];
      //   typeof fun === "function" && fun(this.goods_data.list[table_index]);
      // }

      Object.keys(this.goods_sku_map[goodsNo]).forEach((sku) => {
        const tableIndex = this.goods_sku_map[goodsNo][sku];
        if (typeof fun === "function") {
          fun(this.goods_data.list[tableIndex]);
        }
      });
    },

    // 设置货号的return_day
    setGoodsReturnDay($e, row) {
      // console.log($e, row);
      const params = {
        planid: this.routeParams.planid,
        is_dispense: this.routeParams.is_dispense,
        supply_id: this.routeParams.supply_id,
        goods_no: row.goods_no,
        date: $e,
      };
      this.post(this.urls.set_goods_return_day, params).then(() => {});
    },

    // 显示开单弹窗
    cgDialog(goodsNo) {
      this.$refs.kdDialogRef.calling(goodsNo);
    },

    // 确定开单数量
    confirmDkNum(list, goodsNo) {
      const detail = [];
      // index = [];
      // 代采数量赋值进去列表里面
      list.forEach((row) => {
        detail.push({
          sku: row.sku,
          num: row.cg_num,
        });
      });
      const params = {
        supply_id: this.routeParams.supply_id,
        is_dispense: this.routeParams.is_dispense,
        detail: JSON.stringify(detail),
        action: 1,
        planid: this.routeParams.planid,
      };
      this.post(this.urls.set_num, params).then(() => {
        this.getGoodsFee(goodsNo);
        list.forEach((row) => {
          const idx = this.goods_sku_map[goodsNo][row.sku];
          this.goods_data.list[idx].cg_num = row.cg_num;
        });
      });
    },

    // 全选断货数量
    allStopNum() {
      this.goods_data.list.forEach((row) => {
        row.stop_num = this.calcLeftNum(row);
      });
    },
    // 重置断货数量
    resetStopNum() {
      this.goods_data.list.forEach((row) => {
        row.stop_num = 0;
      });
    },

    // 获取开单信息
    kdInfo() {
      const rs = {
        cg_type: "常规代采", // 交易方式
        total: `${this.calcTotalMap.total_num}/${this.calcTotalMap.total_origin_cg_price}`, // 开单价合计
        activity_fee: this.calcTotalMap.total_activity_fee,
        service_fee: this.calcTotalMap.total_service_fee,
        refund_fee: this.calcTotalMap.total_refund_fee,
        total_price: this.calcTotalMap.total_price, // 实付金额
        // 小店佣金
        store_fee: this.calcTotalMap.store_fee, // 实付金额,
        // service_fee: this.calcTotalMap.total_service_fee,
        total_ded: this.rebateData.total_ded || "0.00",
      };
      return [rs];
    },

    // 选择抵扣商品
    selectDedData() {
      this.$refs.dedTableRef.calling();
    },

    // 确定抵扣商品
    confirmDed(list, sumPrice, sumNum) {
      this.ded_data.list = list;
      this.ded_data.sum_price = sumPrice;
      this.ded_data.sum_num = sumNum;
    },

    // 提交按钮
    submit() {
      // if (this.docs.length == 0) {
      //     return this.$message.e('请上传档口凭证');
      // }

      // if (!this.kd_form.order_type) {
      //     return this.$message.e('请选择实数单或排单单');
      // }

      // 检查是否有断货的, 有断货上传完断货之后才能提交
      this.loading = true;
      this.stopGoods()
        .finally(() => {
          this.loading = false;
        })
        .then(() => {
          return this.$confirm("确定提交开单审核?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        })
        .then(() => {
          this._submit();
        });
    },

    // 提交断货数据
    stopGoods() {
      if (this.calcTotalMap.stop_num == 0) {
        return new Promise((resolve) => {
          resolve({ code: 200 });
        });
      }
      const params = {
        supply_id: this.routeParams.supply_id,
        action: 2,
        detail: [],
        planid: this.routeParams.planid,
        is_dispense: this.routeParams.is_dispense,
      };
      this.goods_data.list.forEach((row) => {
        // if (row.stop_num == 0) return;
        params.detail.push({
          sku: row.sku,
          num: row.stop_num,
        });
      });
      return this.post(this.urls.set_num, params);
    },

    // 确定提交开单
    _submit() {
      this.loading = true;
      const payee = this.billing_info.supply_payee[this.choice_payee] || {};
      const args = {
        cg_type: 0, // 只有常规代采
        supply_id: this.routeParams.supply_id,
        planid: this.routeParams.planid,
        // note:
        ded_detail: this.isAutoDeduct
          ? (this.result.list || []).map((item) => item.wdid).join(",")
          : this.ded_data.list,
        ded_price: this.deductPrice,
        docs: this.docs,
        pgid: this.routeParams.pgid,
        // order_type: this.kd_form.order_type,
        // order_return_day: this.kd_form.order_return_day,
        payee_bank: payee.payee_bank || "",
        payee_bank_account: payee.payee_bank_account || "",
        payee_name: payee.payee_name || "",
        cnap: payee.cnap || "",
        is_dispense: this.routeParams.is_dispense,
        saf_ids:
          !PLAN_IDS.includes(this.routeParams.ptype) && this.isCutActivityGoods
            ? this.saf_ids
            : [],
        open_activity_ded: this.isCutActivityGoods ? "1" : "2",
        open_return_profit_ded: this.openReturnProfitDed
          ? constantMap.isProfitOpen
          : constantMap.isProfitClose,
        rp_ded_price: this.rebateData.total_ded,
        is_auto_ded: this.billing_info.is_auto_ded,
        ...this.kd_form,
      };
      this.post(this.urls.submit, args)
        .then((rs) => {
          if (rs.code === 5204) {
            this.getGoodsList();
            return;
          }
          this.$message.success("开单成功");
          // this.$router.go(-1);
          const home = this.$parent.$parent.$parent.$parent;
          home.removeTab(home.filterUriPrefix(this.$route.path));
        })
        .catch((err) => {
          if (err.code === 5204) {
            this.ded_data = this.$options.data.call(this).ded_data;
            this.getGoodsList();
            this.getBillingInfo();
            this.getActivityGoodsInfo(
              parseFloat(
                this.$math.evaluate(
                  `${this.calcTotalMap.total_price} - ${this.deductPrice}`
                )
              )
            );
            return;
          }
          console.error(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 调起多期页面
    showMultiGoods(goodsNo) {
      this.$refs.multiPhaseGoodsRef.calling(goodsNo);
    },

    // 摸一下断货列表的剩余数量
    tapStopTableLeftNum(row) {
      row.stop_num = this.calcLeftNum(row);
    },

    // 全选开单数量
    setAllCgNum() {
      this.$confirm(
        "全选开单数量会重置全部断货数量<br/>并根据开单款数会造成长时间请求<br/>是否确定",
        "警告",
        {
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          center: true,
        }
      )
        .then(() => {
          // 先断货缓存全部重置
          this.resetStopNum();
          return this.stopGoods();
        })
        .then(() => {
          this._setAllNum(1);
        });
    },

    // 重置全部开单数量
    resetAllCgNum() {
      this.$confirm(
        "重置全部数量会根据开单款数会造成长时间请求<br/>是否确定",
        "警告",
        {
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          center: true,
        }
      ).then(() => {
        this._setAllNum(2);
      });
    },

    // 设置数量
    // @param action {1:全选, 2:重置}
    _setAllNum(action) {
      const params = {
        action: 1,
        supply_id: this.routeParams.supply_id,
        detail: [],
        planid: this.routeParams.planid,
        is_dispense: this.routeParams.is_dispense,
      };
      const getLeftNum = this.calcLeftNum;
      // 判断
      const fun = (() => {
        if (action == 1) {
          return (row) => {
            return row.cg_num + getLeftNum(row);
          };
        }
        return () => {
          return 0;
        };
      })();

      // 设置数量
      this.goods_data.list.forEach((row) => {
        const num = fun(row);
        params.detail.push({
          sku: row.sku,
          num,
        });
        row.cg_num = num;
      });

      // 提交开单数量的缓存
      this.post(this.urls.set_num, params).then(() => {
        if (action == 1) {
          // 一个一个去获取价格
          Object.keys(this.goods_sku_map).forEach((goodsNo) => {
            this.getGoodsFee(goodsNo);
          });
        } else {
          this._resetRowsFee();
        }
      });
      // this.stopGoods().then(_=>{

      // });
    },

    // 重置每行的活动金额和费用
    _resetRowsFee() {
      this.goods_data.list.forEach((row) => {
        row.activity_fee = "0.00";
        row.refund_service_fee = "0.00";
        row.service_fee = "0.00";
        row.total_price = "0.00";
        row.total_num = 0;
      });
    },

    post(url, params) {
      return new Promise((resolve, reject) => {
        this.$http.post(url, params).then((rs) => {
          if (rs.data.code != 200) {
            this.$message.e(rs.data.msg);
            reject(rs.data);
            return;
          }
          resolve(rs.data.data, rs.data.msg);
        });
      });
    },

    priceFormat(arg) {
      return Number(arg).toFixed(2);
    },

    // 计算剩余数量
    calcLeftNum(row) {
      return Math.max(row.plan_num - row.cg_num - row.stop_num, 0);
    },

    // 计算前置数量
    calcDkNum(row) {
      return Math.abs(Math.min(row.plan_num - row.cg_num - row.stop_num, 0));
    },

    // 计算货号下的总断货数量
    calcGoodsStopNum(row) {
      let rs = 0;
      this._loopSku(row.goods_no, (skuRow) => {
        rs += skuRow.stop_num;
      });
      return rs;
    },

    // 浮点数相加 保留两为小数
    _bcAdd(...args) {
      let i = 0;
      args.forEach((v) => {
        i += parseFloat(v);
      });
      return this.priceFormat(i);
    },

    // 实际结算金额=实付金额-商品抵扣-活动费商品抵扣-让利佣金抵扣金额
    settlementAmount(i, j, k, h) {
      // return this.priceFormat(parseFloat(i) - parseFloat(j) - parseFloat(k));
      console.log(
        `${i} - ${j} - ${k} - ${h} = `,
        addZeroes(
          parseFloat(
            this.$math.evaluate(`${i} - ${j} - ${k} - ${h}`).toString()
          )
        )
      );
      return addZeroes(
        parseFloat(this.$math.evaluate(`${i} - ${j} - ${k} - ${h}`).toString())
      );
    },

    // 急救箱数量
    setStockNum(num) {
      this.stock_goods = num;
    },

    showBillingDetail(row) {
      console.log(this.routeParams.is_dispense);
      this.$refs.billingDetailRef.calling(row);
    },

    preview(img) {
      const url = img.response.data.origin_files[0];
      viewImg(url);
    },
    handleDealGoodsInfo() {
      if (!this.isCutActivityGoods) {
        this.activityGoodsInfoStag = this.activityGoodsInfo;
        this.activityGoodsInfo = [];
        this.activityFeeAmountStag = this.activity_fee_amount;
        this.activity_fee_amount = "0.00";
        this.handleGetRebateByMoney();
      } else {
        this.activityGoodsInfo = this.activityGoodsInfoStag;
        this.activity_fee_amount = this.activityFeeAmountStag;
        this.handleGetRebateByMoney();
        // 开启后要重新调接口获取「合计让利佣金抵扣金额」
        // const minuend = parseFloat(
        //   this.$math.evaluate(
        //     `${this.calcTotalMap.total_price} - ${this.activity_fee_amount}`
        //   )
        // );
      }
      this.ded_data = this.$options.data.call(this).ded_data;
    },

    // 根据金额获取抵扣账单
    handleGetRebateByMoney() {
      if (!this.openReturnProfitDed) {
        return;
      }
      // 买版计划不走这个接口
      if(this.isBuyEditionPlan){
        return;
      }

      vendorProfitConcessionApi
        .listReturnProfitBillByAmount({
          amount: completeMoneyDecimal(this.deductActivityPayPrice),
          supply_id: this.routeParams.supply_id,
        })
        .then((res) => {
          this.rebateData = res;
        })
        .catch(this.$noop);
    },

    handleProfitSwitchChange() {
      if (!this.openReturnProfitDed) {
        this.rebateData = {
          list: [],
          total_ded: "0.00",
        };
      } else {
        this.handleGetRebateByMoney();
      }
      this.ded_data = this.$options.data.call(this).ded_data;
    },

    handleFetchSuccess(data) {
      this.result = data;
      this.ded_data.sum_price = Number(data.total_amount);
    },
    handleViewImages(images) {
      this.$viewerApi({
        images,
      });
    },
    handleDeductGoodsConfirm() {
      this.getActivityGoodsInfo(
        parseFloat(
          this.$math.evaluate(
            `${this.calcTotalMap.total_price} - ${this.deductPrice}`
          )
        )
      );
    },
  },
};
</script>

<style scoped>
.header {
  height: 30px;
  border-bottom: 1px solid #ddd;
}

.header span {
  margin-right: 20px;
}

.light-color {
  color: #b7b7b7;
}

.blue-font {
  color: blue;
}

.linear {
  background-image: linear-gradient(
    to bottom right,
    rgb(110, 161, 238),
    rgb(28, 172, 52),
    rgb(145, 34, 248),
    #ccc,
    black,
    rgb(28, 172, 52),
    rgb(110, 161, 238)
  );
  color: #fff;
}

.box {
  margin-top: 20px;
}

.upload-demo {
  display: inline;
}

.splice-line {
  margin-top: 20px;
}

.goods-table {
  width: 100%;
  margin-top: 10px;
}

.image-box {
  width: 80px;
  height: 80px;
}

.red-font {
  color: red;
}

.viewer-img {
  max-width: 100%;
  max-height: 100%;
}

.table-input {
  width: 145px;
}

.pointer {
  cursor: pointer;
}

.full {
  width: 100%;
}

.multi-phase-btn {
  width: 120px;
  background-color: rgb(248, 154, 14);
  border-color: rgb(248, 154, 14);
  color: #fff;
}

.space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.flex-row-reverse {
  display: flex;
  flex-direction: row-reverse;
}

.span-top {
  margin-top: 15px;
  padding: 5px 10px;
  border-radius: 5px;
}

.yellow-background {
  background-color: yellow;
}

.grey-bar {
  /* margin-top:20px */
  background-color: #eee;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.activity-title {
  display: flex;
  justify-content: space-between;
}

.dialog-content {
  text-align: center;
  font-size: 18px;
}
</style>
<style>
.waiting-purchase-detail .el-table__column-filter-trigger {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchaseverify/WaitingPurchaseDetail.vue